//@ts-check

function waitFor(fn, { timeout = 5000, interval = 50 } = {}) {
  return new Promise((resolve, reject) => {
    const start = performance.now();
    (function tick() {
      try {
        const val = fn();
        if (val) return resolve(val);
      } catch {}
      if (performance.now() - start > timeout)
        return reject(new Error("Timed out"));
      setTimeout(tick, interval);
    })();
  });
}

(async () => {
  /** @type {URLSearchParams} */
  const urlParams = new URL(window.location.href).searchParams;
  /** @type { string | null} */
  const worktop = urlParams.get("worktop");

  if (!worktop) return;

  /** @type {HTMLElement | null} */
  const formEmbed = await waitFor(() => document.querySelector("#app-embed"));
  console.log(formEmbed);
  /** @type {ShadowRoot | null | undefined} */
  const formEmbedShadow = await waitFor(() => formEmbed?.shadowRoot);
  console.log(formEmbedShadow);
  /** @type {HTMLInputElement | null | undefined} */
  const worktopField = await waitFor(() =>
    formEmbedShadow?.querySelector(
      '[id="custom#do_you_know_the_name_of_the_worktop_you_require_"]'
    )
  );
  /** @type {HTMLLabelElement | null | undefined} */
  const worktopFieldLabel = await waitFor(() =>
    formEmbedShadow?.querySelector(
      '[id="custom#do_you_know_the_name_of_the_worktop_you_require_"] + label'
    )
  );
  if (!worktopField || !worktopFieldLabel) return;
  worktopField.value = worktop;
  worktopFieldLabel.style.transform = "var(--input-label-transform)";
})();
